import { render, staticRenderFns } from "./AdminSupport.vue?vue&type=template&id=1a7a5a1f&"
import script from "./AdminSupport.vue?vue&type=script&lang=js&"
export * from "./AdminSupport.vue?vue&type=script&lang=js&"
import style0 from "./AdminSupport.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VDialog})
